<button
  type="button"
  class="assistant-trigger"
  [disabled]="disabled"
  [title]="titleKey | translate"
  (click)="triggered.emit()">
  <span class="assistant-trigger__icon">
    <fa-icon [icon]="icon"></fa-icon>
  </span>
  <span class="assistant-trigger__label">{{ labelKey | translate }}</span>
</button>
